




















































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { Resolve } from 'vue-di';

import Header from '~/components/header/Header.vue';
import styles from '~/assets/style/variables.scss';
import SideBar from '~/components/site/sideBar.vue';
import Footer from '~/components/Footer.vue';
import FloatingFooter from '~/components/floating-footer.vue';
import SessionModule from '~/store/session';
import LayoutModule from '~/store/layout';

@Component<AuthenticatedLayout>({
    components: {
        Header,
        SideBar,
        FloatingFooter,
        Footer,
    },
    mounted() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this as any).$meta) (this as any).$meta().refresh();
    },
})
export default class AuthenticatedLayout extends Vue {
    @Resolve
    session!: SessionModule;

    @Resolve
    layout!: LayoutModule;

    styles = styles;
    isExpanded = false;

    @Watch('$route.query', { immediate: true })
    setMagenta() {
        const isMagenta = !!this.$route.query.magenta && this.$route.query.magenta === 'true';
        this.layout.setIsMagenta(isMagenta);
    }

    public back() {
        this.$router.back();
    }
    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }
}
